module.exports = __webpack_public_path__ + "img/iwd.d3288611.png";